import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import LegalBody from "@/components/LegalBody";

export default function LegalModal({ open, onClose, title, body, updated, intro, sections, testId }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid={testId}
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <button
            data-testid={`${testId}-backdrop`}
            aria-label={`Close ${title}`}
            onClick={onClose}
            className="absolute inset-0 bg-ink/40"
          />
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-label={title}
            className="relative w-full max-w-lg bg-ivory rounded-t-3xl sm:rounded-3xl max-h-[85vh] overflow-y-auto no-scrollbar"
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 60, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="sticky top-0 bg-ivory px-6 py-5 flex items-center justify-between border-b border-ink/10">
              <h2 className="font-display uppercase text-2xl tracking-wide">
                {title}
              </h2>
              <button
                data-testid={`${testId}-close`}
                onClick={onClose}
                aria-label="Close"
                className="w-10 h-10 inline-flex items-center justify-center rounded-full bg-ink text-ivory transition-transform duration-150 active:scale-90"
              >
                <X className="w-4 h-4" strokeWidth={3} />
              </button>
            </div>
            <div className="px-6 py-6 space-y-4 text-sm text-ink/80 leading-relaxed">
              <LegalBody
                body={body}
                updated={updated}
                intro={intro}
                sections={sections}
                headingTag="h3"
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
